import { getEnvVar } from "@/config";

const ApiUrl = {
	LEGACY_URL: getEnvVar("apiBaseUrl"),
	USER_SERVICE_URL: getEnvVar("apiUserServiceUrl"),
	AZURE_SERVICE_URL: getEnvVar("apiAzureDevUrl"),
} as const;

export { ApiUrl };
